"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbTime = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sbTextbox = require("../sb-textbox");

var _sbButton = require("../sb-button");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NOOP = function NOOP() {};

var SbTime = /*#__PURE__*/function (_PureComponent) {
  _inherits(SbTime, _PureComponent);

  var _super = _createSuper(SbTime);

  function SbTime() {
    var _this;

    _classCallCheck(this, SbTime);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleValueUpClicked", function (type) {
      _this.handleValueChanged(1, type);
    });

    _defineProperty(_assertThisInitialized(_this), "handleValueDownClicked", function (type) {
      _this.handleValueChanged(-1, type);
    });

    _defineProperty(_assertThisInitialized(_this), "handleValueChanged", function (increment, type) {
      var _this$props = _this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          localeFormat = _this$props.localeFormat;
      onChange({
        date: (0, _utils.getChangedTime)({
          value: value,
          type: type,
          increment: increment,
          localeFormat: localeFormat
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (newValue, type) {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          onChange = _this$props2.onChange,
          localeFormat = _this$props2.localeFormat;
      var newTime = (0, _utils.getChangedInputTime)({
        value: value,
        type: type,
        newValue: newValue,
        localeFormat: localeFormat
      });

      if (newTime) {
        onChange({
          date: newTime
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderBox", function (_ref) {
      var type = _ref.type,
          isAmPm = _ref.isAmPm,
          isFirst = _ref.isFirst;
      var value = _this.props.value;
      var key = "get".concat(type[0].toUpperCase()).concat(type.substr(1, type.length));
      var valueToDisplay = null;
      var ampmHours = value.getHours() % 12 === 0 ? 12 : value.getHours() % 12;

      if (value) {
        if (type === 'ampm') {
          valueToDisplay = value.getHours() < 12 ? 'AM' : 'PM';
        } else if (type === 'hours') {
          valueToDisplay = isAmPm ? ampmHours : value.getHours();
        } else {
          valueToDisplay = value[key]();
        }
      }

      if (typeof valueToDisplay === 'number' && valueToDisplay < 10) {
        valueToDisplay = "0".concat(valueToDisplay);
      }

      return _this.renderInput({
        value: valueToDisplay,
        type: type,
        isFirst: isFirst
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref2) {
      var value = _ref2.value,
          type = _ref2.type,
          isFirst = _ref2.isFirst;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, isFirst ? null : /*#__PURE__*/_react.default.createElement("div", {
        className: "time-separator"
      }, ":"), /*#__PURE__*/_react.default.createElement("div", {
        className: "time-box"
      }, /*#__PURE__*/_react.default.createElement(_sbButton.SbButton, {
        className: "time-change-button",
        onClick: function onClick() {
          _this.handleValueUpClicked(type);
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "sbi-chevron-up"
      })), /*#__PURE__*/_react.default.createElement(_sbTextbox.SbTextbox, {
        value: value,
        onChange: function onChange(event) {
          return _this.handleInputChange(event.target.value, type);
        }
      }), /*#__PURE__*/_react.default.createElement(_sbButton.SbButton, {
        className: "time-change-button",
        onClick: function onClick() {
          _this.handleValueDownClicked(type);
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "sbi-chevron-down"
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPicker", function () {
      var _this$props3 = _this.props,
          format = _this$props3.format,
          localeFormat = _this$props3.localeFormat;

      var _checkForTimeFormat = (0, _utils.checkForTimeFormat)(localeFormat),
          isAmPm = _checkForTimeFormat.isAmPm;

      var hour = format.hour,
          minute = format.minute,
          second = format.second,
          millisecond = format.millisecond;
      var isFirst = true;
      var hourBox = null;
      var minuteBox = null;
      var secondBox = null;
      var millisecondBox = null;
      var ampmBox = null;

      if (hour) {
        hourBox = _this.renderBox({
          type: 'hours',
          isAmPm: isAmPm,
          isFirst: true
        });
        isFirst = false;
      }

      if (minute) {
        minuteBox = _this.renderBox({
          type: 'minutes',
          isFirst: isFirst
        });
        isFirst = false;
      }

      if (second) {
        secondBox = _this.renderBox({
          type: 'seconds',
          isFirst: isFirst
        });
        isFirst = false;
      }

      if (millisecond) {
        millisecondBox = _this.renderBox({
          type: 'milliseconds',
          isFirst: isFirst
        });
      }

      if (isAmPm && hour) {
        ampmBox = _this.renderBox({
          type: 'ampm',
          isFirst: true
        });
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-time-pickers"
      }, hourBox, minuteBox, secondBox, millisecondBox, ampmBox);
    });

    return _this;
  }

  _createClass(SbTime, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          open = _this$props4.open,
          timeRef = _this$props4.timeRef,
          className = _this$props4.className;

      if (!open) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(className, 'sb-time'),
        ref: timeRef
      }, this.renderPicker());
    }
  }]);

  return SbTime;
}(_react.PureComponent);

exports.SbTime = SbTime;

_defineProperty(SbTime, "propTypes", {
  open: _propTypes.default.bool,
  format: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  value: _propTypes.default.instanceOf(Date),
  timeRef: _propTypes.default.func,
  onChange: _propTypes.default.func,
  className: _propTypes.default.string,
  localeFormat: _propTypes.default.object.isRequired // eslint-disable-line react/forbid-prop-types

});

_defineProperty(SbTime, "defaultProps", {
  open: false,
  format: 'hh:ss:mm:SS',
  value: new Date(),
  className: null,
  timeRef: NOOP,
  onChange: NOOP
});
//# sourceMappingURL=sb-time.js.map